const updates = [
  {
    id: 1,
    time: '10分钟前',
    title: '某顶流男星工作室发布声明否认恋情传闻，称将通过法律途径维权',
    type: '快讯',
  },
  {
    id: 2,
    time: '28分钟前',
    title: '热门综艺《星光大道》宣布暂停录制，制片方称因设备检修',
    type: '突发',
  },
  {
    id: 3,
    time: '1小时前',
    title: '知名歌手新专辑被曝抄袭，网友晒出多首曲目对比音频',
    type: '热议',
  },
  {
    id: 4,
    time: '2小时前',
    title: '某上市娱乐公司股价暴跌15%，传旗下多名艺人合约到期不续',
    type: '财经',
  },
  {
    id: 5,
    time: '3小时前',
    title: '网传某选秀节目冠军内定，节目组官方微博评论区沦陷',
    type: '热议',
  },
  {
    id: 6,
    time: '5小时前',
    title: '短视频平台网红收入排行榜引争议，多位头部主播否认数据真实性',
    type: '焦点',
  },
  {
    id: 7,
    time: '7小时前',
    title: '某国际电影节公布入围名单，三部华语作品入选主竞赛单元',
    type: '资讯',
  },
];

const typeStyles: Record<string, string> = {
  '快讯': 'bg-primary-100 text-primary-700',
  '突发': 'bg-red-100 text-red-600',
  '热议': 'bg-accent-100 text-accent-700',
  '财经': 'bg-secondary-100 text-secondary-700',
  '焦点': 'bg-accent-100 text-accent-700',
  '资讯': 'bg-secondary-100 text-secondary-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">最新动态</h2>
          <p className="text-foreground-500 text-sm">实时追踪，不放过任何一个热点</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-background-200">
            {updates.map((item, i) => (
              <div key={item.id} className={`relative pb-8 ${i === updates.length - 1 ? 'pb-0' : ''}`}>
                <div className="absolute -left-[calc(1.25rem+1px)] top-0 w-4 h-4 rounded-full bg-primary-500 border-2 border-background-50"></div>
                <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 mb-1">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                  <span
                    className={`inline-block px-2 py-0.5 rounded text-[10px] font-medium whitespace-nowrap w-fit ${
                      typeStyles[item.type] || 'bg-background-200 text-foreground-600'
                    }`}
                  >
                    {item.type}
                  </span>
                </div>
                <a href="#updates" className="block text-sm text-foreground-800 hover:text-primary-600 transition-colors leading-relaxed cursor-pointer">
                  {item.title}
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}